import { Form, Mentions, Select } from 'antd'
import { useCallback, useMemo, useState } from 'react'

export default function List({ parameters, fieldName }) {
  const available = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr.map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  const availableNumbers = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr
      .filter(({ type }) => type === 'integer')
      .map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item
        label={'A partir de'}
        name={[fieldName, 'action', 'data', 'from']}
      >
        <Select placeholder={'Horário'} options={available} />
      </Form.Item>
      <Form.Item
        label={'Quantidade'}
        name={[fieldName, 'action', 'data', 'quantity']}
      >
        <Mentions
          placeholder={'Quantidade de horários'}
          options={availableNumbers}
          prefix={'$'}
        />
      </Form.Item>
    </>
  )
}
